import { Component, Input, OnDestroy} from '@angular/core';
import { ServiceLineCountup } from '@shared/model/service-line-countup.interface';

@Component({
    selector: 'service-line-countup',
    templateUrl: './service-line-countup.component.html',
    styleUrls: ['./service-line-countup.component.scss'],
    standalone: false
})
export class ServiceLineCountupComponent implements OnDestroy {
  private _timerDetails: ServiceLineCountup;

  anticipatedTime: number = 0; // in milliseconds
  private timer: any;
  showBlueIcon?: boolean;

  @Input()
  set data(value: ServiceLineCountup) {
    this._timerDetails = { ...value };

    // STOP TIMER IF ALREADY ADJUDICATED
    if (this._timerDetails.clinicalReviewAdjudicationDate) {
      this.showBlueIcon = false;
      this.clearTimer();
      this.anticipatedTime = this._timerDetails.elapsedBusinessTime;
      this.isShowBlueIcon();
      return;
    }
      this.adjustElapsedTime(); //  Add delta based on fetch time
      this.startTimer();        //  Start timer if valid
  }

  private isShowBlueIcon() {
    const anticipatedDate = this._timerDetails.anticipatedManualDecisionDate
      ? new Date(this._timerDetails.anticipatedManualDecisionDate).getTime()
      : null;
    this.showBlueIcon = anticipatedDate ? Date.now() > anticipatedDate : false;
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }

  private startTimer(): void {
    this.clearTimer(); // clear previous if any
    this.showBlueIcon = false;

    const timerInfo = this._timerDetails;

    const stopTime = new Date(timerInfo.nextNonBusinessDate).getTime();
    const shouldRun = timerInfo.isBusinessDayNow && Date.now() < stopTime;

    this.anticipatedTime = timerInfo.elapsedBusinessTime;

    if (!shouldRun) {
      return; // Only display static time
    }

    this.timer = setInterval(() => {
      const now = Date.now();
      this.isShowBlueIcon();
      if (now >= stopTime) {
        this.clearTimer();
        return;
      }
      this.anticipatedTime += 1000; // increment by 1 second
    }, 1000);
  }

  private adjustElapsedTime(): void {
  const now = Date.now();


  const fetchedAtStr = sessionStorage.getItem('elapsedTimeFetchedAt');
  const fetchedAt = fetchedAtStr ? parseInt(fetchedAtStr, 10) : now;

  const nextNonBusinessDate = new Date(this._timerDetails.nextNonBusinessDate).getTime();
  const shouldRun = this._timerDetails.isBusinessDayNow && now < nextNonBusinessDate;

  if (!shouldRun) {
    return; // Timer should not move forward
  }

  // Only count time until nextNonBusinessDate

  //const safeNow = Math.min(now, nextNonBusinessDate);
  //const delta = safeNow - fetchedAt;
  const delta = now - fetchedAt;

  if (delta > 0) {
    this._timerDetails.elapsedBusinessTime += delta;
  }
}


  private clearTimer(): void {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}
